import { getEditLocation } from "../../../core/util/functions";

export const banksLocation = "/listing/codebook/banks";
export const getBankEditLocation = (id?: string) => getEditLocation(banksLocation, undefined, id);

export const editRouter = getBankEditLocation(":bankId?");
